import { render, staticRenderFns } from "./EmptyDownloads.vue?vue&type=template&id=2025aea8&scoped=true"
import script from "./EmptyDownloads.vue?vue&type=script&lang=js"
export * from "./EmptyDownloads.vue?vue&type=script&lang=js"
import style0 from "./EmptyDownloads.vue?vue&type=style&index=0&id=2025aea8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2025aea8",
  null
  
)

export default component.exports